export default "__VITE_ASSET__c4e08d36__"